import { Badge, Code, Paper, Stack, Text } from '@mantine/core';

import { getStatusColor } from '../request-logger.utils';

import type { RequestLog } from '@admin/hooks';
interface ResponseTabProps {
  request: RequestLog;
}

export const ResponseTab = ({ request }: ResponseTabProps) => {
  return (
    <Stack gap="md">
      <Paper withBorder p="md">
        <Text size="sm" fw={600} mb="xs">
          Response Status
        </Text>
        <Badge size="lg" color={getStatusColor(request.response?.status)}>
          {request.response?.status || 'N/A'}
        </Badge>
      </Paper>

      {request.response?.headers && Object.keys(request.response.headers).length > 0 && (
        <Paper withBorder p="md">
          <Text size="sm" fw={600} mb="xs">
            Response Headers
          </Text>
          <Code block style={{ maxHeight: '300px', overflow: 'auto' }}>
            {JSON.stringify(request.response.headers, null, 2)}
          </Code>
        </Paper>
      )}

      {request.response?.body && (
        <Paper withBorder p="md">
          <Text size="sm" fw={600} mb="xs">
            Response Body
          </Text>
          <Code block style={{ maxHeight: '500px', overflow: 'auto' }}>
            {typeof request.response.body === 'string' ? request.response.body : JSON.stringify(request.response.body, null, 2)}
          </Code>
        </Paper>
      )}
    </Stack>
  );
};
